export default __webpack_public_path__ + "static/media/10-EXT-(4-3).ae903565.jpg";